import type { FaireProductEntity } from "../../entity_types/product";

export const p_szvdu4d8ma: FaireProductEntity = {
  token: "p_szvdu4d8ma",
  type: "product",
  name: "Satya Palo Santo Smudge Incense 25 gms",
  brandToken: "b_pfe5z89pnk",
  brandName: "Vrinda",
  imageUrl:
    "https://cdn.faire.com/fastly/4ca5ffaa870012dd77618a4a5a67308a12e0249a74966178aca0ce7546b8eedb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6128cd13462423842236dab64786162f50ddb8e998a98c3deedb45796d8ce9f.jpeg",
    "https://cdn.faire.com/fastly/78cf7c77da14b32be9caa015566b0c6e1540b6f2c49a4d1a495bc1be85388bb3.jpeg",
  ],
  priceDollars: 16.61,
  description:
    "Satya Palo Santo Smudge Incense 25 gms is an exceptional offering from Vrinda, a family-owned business dedicated to creating products that support mindfulness and well-being. With its soothing aroma, this premium incense is designed to promote balance and spiritual connection. Ideal for meditation or creating a tranquil atmosphere, this incense adds an element of sacred living to your routine. Enjoy the rich, grounding fragrance of Palo Santo, renowned for its healing properties. Find peace in every breath with Vrinda.",
  tags: [],
  msrpDollars: 33.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:46.153Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
